import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';

/*
  Generated class for the SubjectProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SubjectProvider {

    url: string = 'http://qbankapiv2.showmywork.in/student/';

    constructor(public http: HttpClient) {
        console.log('Hello SubjectProvider Provider');
    }
 
    getStudentSubject() {
        return this.http.get(this.url + 'getStudentSubject').map(res => res);
    }

    getStudentPaper(guid) {
        return this.http.get(this.url + 'getStudentPaper/' + guid).map(res => res);
    }
    
    getQuestionPaperById(guid) {
        return this.http.get(this.url + 'getQuestionPaperById/' + guid).map(res => res);
    }
    addResult() {
        return this.http.get(this.url + 'addResult').map(res => res);
    }
}



// WEBPACK FOOTER //
// ./src/providers/subject.ts